import { AlertTriangle, CheckCircle2 } from "lucide-react";

export default function TrendBrief({ brief }) {
  return (
    <div className="mt-5 space-y-5" data-testid="trends-brief">
      <div>
        <div className="font-display text-xl font-extrabold leading-snug" data-testid="trends-brief-headline">{brief.headline}</div>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{brief.summary}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {(brief.patterns || []).map((p, i) => (
          <div key={i} className="rounded-lg border border-border bg-muted/30 p-4">
            <div className="text-sm font-semibold">{p.title}</div>
            <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{p.insight}</p>
            <div className="mt-2 font-mono text-[10px] text-primary">{p.evidence}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-muted-foreground font-medium mb-2">Next week's playbook</div>
          <ul className="space-y-1.5">
            {(brief.playbook || []).map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm">
                <CheckCircle2 className="h-4 w-4 text-[hsl(var(--emerald))] mt-0.5 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        {brief.watch_out && (
          <div className="rounded-lg border border-[hsl(var(--amber)/0.4)] bg-[hsl(var(--amber)/0.08)] p-4">
            <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-medium text-[hsl(var(--amber))]"><AlertTriangle className="h-3.5 w-3.5" /> Watch out</div>
            <p className="text-sm mt-1.5">{brief.watch_out}</p>
          </div>
        )}
      </div>
    </div>
  );
}
